import React, { useEffect, useState } from "react";
import { Map, Marker, GoogleApiWrapper, Polyline } from "google-maps-react";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";

function MilestoneMapComponent(props) {
  const [coordinate, setCoordinate] = useState([]);
  const [polyline, setPolyline] = useState([]);

  const [bounds, setBounds] = useState(new props.google.maps.LatLngBounds());

  console.log("This is the map component.")

  useEffect(() => {
    setCoordinate(props.mapData);
    const arr = [];
    let bound = new props.google.maps.LatLngBounds();

    props.mapData.map((ele, index) => {
      ele.path.map((item) => {
        const obj = {
          lat: parseFloat(item[0]),
          lng: parseFloat(item[1])
        };
        arr.push(obj);

        bound.extend(obj);
      });

      // if (index != 2) {

      // }
    });
    setBounds(bound);
    setPolyline([...arr]);
  }, [props]);

  // console.log("polyline", polyline, coordinate, props, bounds);

  return (
    <Map
      google={props.google}
      style={{ width: "100%", height: "100%", position: "relative" }}
      className={"map"}
      bounds={bounds}
    >
      {polyline.map((item, index) => {
        if (index === 0 || index === polyline.length - 1) {
          return (
            <Marker
              position={item}
              title={`lat=${item.lat}, lng=${item.lng}`}
            />
          );
        }
      })}
      {Object.keys(props.currentPin).length && (
        <Marker title="Current Location" position={props.currentPin} />
      )}

      {/* {!props.loading &&
        coordinate.length != 0 &&
        coordinate.map((item) => {
          const title = `Country: ${item.country} \nState: ${item.state}\nName: ${item.name} \nLoco Code: ${item.locode}`;
          return (
            <Marker
              // title={title}
              // name={"SOMA"}
              position={{ lat: parseFloat(item.lat), lng: item.lng }}
            />
          );
        })} */}
      {polyline.length != 0 && !props.loading && (
        <Polyline
          path={polyline}
          strokeColor="#0000FF"
          strokeOpacity={0.8}
          strokeWeight={2}
          fillColor="#0000FF"
          fillOpacity={1}
          options={{
            strokeColor: "#ff2527",
            strokeOpacity: 0.75,
            strokeWeight: 2,
            icons: [
              {
                icon: {
                  path: props.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                  strokeOpacity: 0,
                  fillColor: "#ff2527",
                  fillOpacity: 1.0,
                  scale: 4
                },
                repeat: "80px"
              }
            ]
          }}
        />
      )}
    </Map>
  );
}
export default GoogleApiWrapper({
  apiKey: "AIzaSyDpfWeLTpZm0lhuv7_s-8cvKv_8sxJUHD0"
})(React.memo(MilestoneMapComponent));
